/** POS role ids (lenders_backoffice Role model). */
export const RETAIL_ROLE_COMMERCIAL_ID = 4;
export const RETAIL_ROLE_POS_ADMIN_ID = 8;

/** POS role aliases returned by retail /login. */
export const RETAIL_ROLE_SELLER_ALIAS = 'seller';
export const RETAIL_ROLE_POS_ADMIN_ALIAS = 'pos-admin';

export const isPosAdminRole = (role) =>
  role?.alias === RETAIL_ROLE_POS_ADMIN_ALIAS
  || Number(role?.id) === RETAIL_ROLE_POS_ADMIN_ID;
